import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../api";
import { useI18n } from "../i18n";
import { LOGO, Card, Badge, Spinner, EmptyState, Button } from "../components/ui";

export default function QRAccess() {
  const [params] = useSearchParams();
  const { t } = useI18n();
  const token = params.get("token");
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!token) { setErr(true); return; }
    api.get(`/access/${token}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [token]);

  if (err) return <Centered><EmptyState title="Lien invalide ou expiré" hint="Demandez un nouveau code QR à votre cabinet." /></Centered>;
  if (!data) return <Centered><Spinner /></Centered>;

  const prog = data.program;
  const exMap = {}; (data.exercises || []).forEach((e) => (exMap[e.id] = e));

  return (
    <div className="min-h-screen bg-vlg">
      <header className="bg-navy text-white h-14 flex items-center px-4 gap-2">
        <img src={LOGO} className="h-8 w-8 object-contain bg-white rounded-lg p-0.5" alt="" />
        <span className="font-head font-bold">Spina<span className="text-teal-400">Go</span></span>
        <Link to="/connexion" className="ms-auto text-sm text-teal-400">{t("nav_login")}</Link>
      </header>
      <main className="max-w-2xl mx-auto p-4 space-y-4">
        <Card className="p-5">
          <Badge tone="teal" className="mb-2">Accès sécurisé par jeton</Badge>
          <h1 className="font-head font-bold text-navy text-xl">{data.patient_name}</h1>
          <p className="text-sm text-slate-500">{prog.goal} · v{prog.version} · {t("reeval_date")}: {prog.reeval_date || "—"}</p>
        </Card>
        {(prog.items || []).map((it, i) => {
          const ex = exMap[it.exercise_id];
          return (
            <Card key={`${it.exercise_id}-${i}`} className="p-4">
              <div className="flex gap-3">
                <div className="h-16 w-16 rounded-lg bg-slate-100 overflow-hidden shrink-0">{ex?.image_url && <img src={ex.image_url} alt="" className="h-full w-full object-cover" />}</div>
                <div><div className="font-medium text-navy">{i + 1}. {ex?.name_fr}</div>
                  <div className="text-xs text-slate-400 mt-0.5">{it.sets} × {it.reps} · {it.frequency} · {it.duration}</div>
                  {ex?.instructions && <p className="text-sm text-slate-500 mt-1">{ex.instructions}</p>}</div>
              </div>
            </Card>
          );
        })}
        <p className="text-xs text-slate-400 text-center py-4">Connectez-vous au portail patient pour enregistrer votre progression.</p>
        <Link to="/connexion"><Button className="w-full">{t("nav_patient_access")}</Button></Link>
      </main>
    </div>
  );
}

function Centered({ children }) {
  return <div className="min-h-screen bg-vlg flex items-center justify-center p-6">{children}</div>;
}
